import React from 'react';
const RefundPolicyPage = () => {
  return <div data-id="element-496">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-497">
        <div className="container mx-auto px-4" data-id="element-498">
          <div className="max-w-3xl mx-auto text-center" data-id="element-499">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-500">
              Refund Policy
            </h1>
            <p className="text-lg text-gray-200" data-id="element-501">
              Information about our refund terms and procedures
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-502">
        <div className="container mx-auto px-4" data-id="element-503">
          <div className="max-w-3xl mx-auto" data-id="element-504">
            <div className="prose prose-lg max-w-none" data-id="element-505">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-506">
                Refund Policy – PinnacleHub
              </h2>
              <p className="mb-6" data-id="element-507">
                Thank you for choosing PinnacleHub. We value your trust and are
                committed to ensuring your complete satisfaction with our
                services. If you have any concerns about your service plan or
                purchase, we'll work quickly and fairly to resolve them.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-508">
                Cancellation & Refund Rights
              </h3>
              <p className="mb-6" data-id="element-509">
                You have the right to cancel your service plan within 14 days of
                purchase and receive a full refund. To do this, please contact
                us within the 14-day period, and we'll process your refund
                promptly.
              </p>
              <p className="mb-6" data-id="element-510">
                If you cancel after 14 days but within 28 days of purchase, you
                may be eligible for a partial refund at our discretion,
                depending on any services already provided under your plan.
              </p>
              <p className="mb-6" data-id="element-511">
                Please note that refunds or cancellations are not available
                after 28 days from the purchase date. We recommend reviewing
                your service plan carefully and contacting us as soon as
                possible if you wish to cancel.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-512">
                How to Request a Refund
              </h3>
              <p className="mb-6" data-id="element-513">
                To request a refund, please get in touch with our team using the
                contact details below:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-514">
                <li className="mb-2" data-id="element-515">Phone: 0800 055 4969</li>
                <li className="mb-2" data-id="element-516">Email: Bikashbuddha2004@gmail.com</li>
              </ul>
              <p className="mb-6" data-id="element-517">
                We'll assess your request promptly and process any approved
                refunds. You'll receive confirmation once your refund has been
                completed.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-518">
                Payment Methods
              </h3>
              <p className="mb-6" data-id="element-519">PinnacleHub accepts payments via:</p>
              <ul className="list-disc pl-6 mb-6" data-id="element-520">
                <li className="mb-2" data-id="element-521">Phone card payments</li>
                <li className="mb-2" data-id="element-522">Online payments through our website</li>
                <li className="mb-2" data-id="element-523">
                  Cheques by post (please contact us for details)
                </li>
                <li className="mb-2" data-id="element-524">BACS or Direct Debit</li>
              </ul>
              <p className="mb-6" data-id="element-525">
                Your 14-day cancellation right applies regardless of payment
                method.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-526">
                Refund Processing
              </h3>
              <p className="mb-6" data-id="element-527">
                All refunds will be issued to the original payment method used
                at purchase. For security reasons, refunds cannot be made to
                alternative accounts or cards.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-528">
                Payment Follow-Up
              </h3>
              <p className="mb-6" data-id="element-529">
                After purchasing a plan, PinnacleHub will contact you to confirm
                activation and inform you when payment will be processed. Please
                ensure sufficient funds are available. If payment fails, we'll
                contact you to confirm whether you wish to proceed. Without a
                timely response, your plan will be cancelled.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-530">
                Authorised Payments
              </h3>
              <p className="mb-6" data-id="element-531">
                Payments must be made by the plan holder or an authorised
                individual. We don't accept payments made under power of
                attorney or other third-party authorisations.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-532">
                Claims & Support
              </h3>
              <p className="mb-6" data-id="element-533">
                To book a repair or submit a claim, please contact us
                immediately:
              </p>
              <ul className="list-disc pl-6 mb-6" data-id="element-534">
                <li className="mb-2" data-id="element-535">Email: Bikashbuddha2004@gmail.com</li>
                <li className="mb-2" data-id="element-536">Phone: 0800 055 4969</li>
              </ul>
              <p className="mb-6" data-id="element-537">
                Our team will assist you and begin the repair process promptly.
              </p>
              <h3 className="text-xl font-semibold text-[#0a3d62] mt-8 mb-4" data-id="element-538">
                Dispute Resolution
              </h3>
              <p className="mb-6" data-id="element-539">
                If you have any issues related to payment or service, please
                contact PinnacleHub first before raising a chargeback with your
                bank. We aim to resolve all concerns fairly and promptly.
                Initiating a chargeback without prior contact may delay your
                refund.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default RefundPolicyPage;